import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BreadcrumbSection() {
  return <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-3644">
      <a href="/" className="hover:text-orange transition-colors" data-id="element-3645">
        Home
      </a>
      <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-3646" />
      <span className="text-navy font-semibold" data-id="element-3647">Seibu Wire EDM</span>
    </div>;
}